// extracted by mini-css-extract-plugin
module.exports = {"image":"Skill_image__ve7Dn"};